// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__A-LGv","approved":"Status_approved__1h8vv","rejected":"Status_rejected__1WENf","expired":"Status_expired__w2iEb","label":"Status_label__3xRcA"};